import { CatalogsService } from './../../../services/catalogs/catalogs.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Validators, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ToasterModule, ToasterService, Toast, ToasterConfig } from 'angular5-toaster';
import { EMService } from './../../../services/invoices-em/em.service';
import { StorageService } from '../../../services/storage.service';
import { User } from '../../../models/user';
import { TranslateService } from '@ngx-translate/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ResponseModal2Component } from './../../../components/response-modal2/response-modal2.component';


@Component({
  selector: 'app-upload-modal',
  templateUrl: './upload-modal.component.html',
  styleUrls: ['./upload-modal.component.scss'],
  providers: [EMService, CatalogsService]
})
export class UploadModalComponent implements OnInit {

  public user: User;
  @ViewChild('myTable') table: any;
  @ViewChild('myTable') tables: DatatableComponent;
  closeResult: string;

  rows: any[] = [];
  expanded: any = {};
  selected = [];

  sociedadOKFI;
  paisDeProveedor;
  entradasMercanciaSeleccionadas = [];
  totalOC;
  cerrarModal;
  proveedor;
  arrayXml = [];
  uploadXml;
  arrayPdf = [];
  uploadPdf;
  flagPDF = false;
  flagXML = false;
  nombrePDF;
  nombreXML;
  importe = 0;
  monedaSeleccionada;
  entradasMercanciaTmp = [];
  ordenCompraTmp = [];
  objJSONCabecera;
  objJSONRecords;
  identificadorDeLlamada;
  usuario;
  moneda;
  monedaValue;
  referencia;
  flagCfdi = false;
  flagConCfdi = false;
  paisUsuario;
  modalRespuesta;
  respuesta;
  titulo;
  mensaje;
  mensaje1;
  busy: boolean = false;
  autenticado;
  toastCargarArchivos;
  notaC: boolean = false;
  toggleMultiplesFacts: boolean = false;
  multiples = false;
  conNotaCredito: boolean = false;
  checkNotaCredito = false;
  datos: any = [];
  importeValue;
  personaContacto;
  importeNC;
  notaXML;
  notaPDF;
  cargaArchivosTitulo;
  cargaArchivos;
  errorEnvioDatos;
  envioDatos;
  verMensaje = false;
  estatusEnvio;
  pdf = "";
  xml = "";

  h;
  rowTable = []; rT = [];
  check;

  public form: FormGroup;
  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });
  constructor(
    private translate: TranslateService,
    private storageService: StorageService,
    private emService: EMService,
    private catalogos: CatalogsService,
    public activeModal: NgbActiveModal,
    private toasterService: ToasterService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder
  ) {
    this.translate.get('texto.toastCamposVacios').subscribe(
      text => {
        this.toastCargarArchivos = text;
      });
    this.translate.get('texto.cargarTodosLosArchivosTitulo').subscribe(
      text => {
        this.cargaArchivosTitulo = text;
      });
    this.translate.get('texto.cargarTodosLosArchivos').subscribe(
      text => {
        this.cargaArchivos = text;
      });
    this.translate.get('texto.tituloEnvioDatosError').subscribe(
      text => {
        this.errorEnvioDatos = text;
      });
    this.translate.get('texto.datosEnviados').subscribe(
      text => {
        this.envioDatos = text;
      });
  }


  noMostrarError = false
  ngOnInit() {  
    this.noBack();
    this.user = this.storageService.getCurrentUser();
    this.paisUsuario = this.paisDeProveedor; 
    // this.rows = this.entradasMercanciaSeleccionadas;
    this.llenarTabla();
    this.importeTotal();
    this.obtenerMoneda();
    this.autenticado = this.storageService.isAuthenticated();

    this.form = this.formBuilder.group({
      correo: ['', Validators.compose([Validators.required,
      Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$'),
      Validators.minLength(1)])],
      total:['', Validators.compose([Validators.required, this.confirmationValidator])],
      folio:['', Validators.compose([Validators.required, Validators.maxLength(16)])]
    });
    // this.form.get('total').valueChanges.subscribe(value => { console.log(value)
      
    //   if (value == null || value == undefined || value == '' || value == 0) {
    //     this.noMostrarError = true
    //   }else{
    //     this.noMostrarError = false
    //   }
      
    //  })
  }
  confirmationValidator = (control: FormControl): { [ s: string ]: boolean } => {
    if (control.value == null || control.value == undefined || control.value == '' || control.value == 0) {
      return { confirm: false, error: false };
    } 
    else if(!Number(control.value)){
      return { confirm: true, error: true };
    }
    
  };
  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  onSelect(rows) {
    // console.log(rows);
  }


  llenarTabla() {
    this.rows = this.entradasMercanciaSeleccionadas;

  }

  obtenerMoneda() {
    this.catalogos.obtenerMonedaPorModulo('P').subscribe(
      data => {
        this.moneda = data.moneda;
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  importeTotal() {
    let total;

    this.monedaSeleccionada = this.entradasMercanciaSeleccionadas[0].clave_moneda;
    for (let i = 0; i < this.rows.length; i++) {
      total = parseFloat(this.rows[i].importe);
      this.importe += total;
    }

  }

  toggleExpandRow(row) {
    this.table.rowDetail.toggleExpandRow(row);
  }


  closeModal(mensaje) {
    if (mensaje == 'cancelar') {
      this.verMensaje = false;
      if (this.estatusEnvio == 'S') {
        this.activeModal.close('cerrar');
      }
    } else {
      this.activeModal.close('cancelar');
    }

  }

  openMensajeRespuesta(mensajeRes) {
    this.modalRespuesta = this.modalService.open(mensajeRes, { centered: true, keyboard: false, backdrop: 'static' });
    this.modalRespuesta.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  cargarNotaCredito(e, notaCredito) {

    if (e.isTrusted) {
      this.conNotaCredito = true;
      /*this.modalRespuesta = this.modalService.open(notaCredito, {centered: true, keyboard: false, backdrop: 'static',size: 'lg', backdropClass: 'modal-backdrop2'});
      this.modalRespuesta.result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
        (<HTMLInputElement>document.getElementById('notaC')).checked = false;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        console.log('c2')
      }); */
    }

  }

  archivosNC(file11: File, file22: File) {
    this.notaXML = file22;
    this.notaPDF = file11;
    this.importeNC = this.importeValue;
    this.conNotaCredito = false;
    this.checkNotaCredito = true;
  }

  cerrarNC() {

    this.conNotaCredito = false;
    this.checkNotaCredito = false;

  }

  multiplesFacts(multiples) {
    if (multiples) {
      this.toggleMultiplesFacts = true;
    } else {
      this.toggleMultiplesFacts = false;
    }
  }

  uploadFile(e, i) {
    if (e.target.files[0].type == 'application/pdf') {
      var nombre = e.target.files[0].name;

      if (nombre.length > 20) {
        nombre = nombre.substring(0, 20) + '...';
      }

      (<HTMLSpanElement>document.getElementById("file-name" + i)).innerHTML = nombre;
    }
  }

  uploadFileXML(e, i) {
    if (e.target.files[0].type == 'text/xml') {
      var nombre = e.target.files[0].name;

      if (nombre.length > 20) {
        nombre = nombre.substring(0, 20) + '...';
      }

      (<HTMLSpanElement>document.getElementById("file-name2" + i)).innerHTML = nombre;
    } 
  }


  enviarDatos(filePDF: File, fileXML: File) {
    this.datos = [];
    this.entradasMercanciaTmp = [];
    this.usuario = this.user.id;
    let proveedor, cfdi;
    var archivosMultiples = false;
    var entradas = [];
    var enviar, nombreXML, nombrePDF;

    if (this.proveedor) {
      proveedor = this.proveedor
    } else {
      proveedor = this.user.id
    }

    var idUsuario;
    if (this.user.rol.id == 3) {
      idUsuario = this.user.id;
    } else {
      idUsuario = this.proveedor;
    }

    if (this.paisUsuario == 'MX') {
      cfdi = false;
    } else {
      cfdi = true;
    }

    if (!this.checkNotaCredito) {
      this.notaPDF = '';
      this.notaXML = '';
      this.importeNC = '';
    }

    if (filePDF) {
      nombrePDF = filePDF.name;
      // var pdfLength = nombrePDF.length;
      // pdfLength = pdfLength - 4;
      // nombrePDF = nombrePDF.substring(0,pdfLength);
    } else {
      nombrePDF = '';
    }

    if (fileXML) {
      nombreXML = fileXML.name;
      //   var xmlLength = nombreXML.length; 
      //   xmlLength = xmlLength - 4;
      //   nombreXML = nombreXML.substring(0,xmlLength); 
    } else {
      nombreXML = '';
    }

    if (this.personaContacto == undefined) this.personaContacto = '';

    var ordenCompra: any = {
      idOrdenCompra: this.entradasMercanciaSeleccionadas[0].num_doc_comp,
      idProveedor: idUsuario,
      sociedad: this.entradasMercanciaSeleccionadas[0].sociedad,
      moneda: this.entradasMercanciaSeleccionadas[0].clave_moneda,
      totalOc: this.totalOC
    };

    for (let i = 0; i < this.entradasMercanciaSeleccionadas.length; i++) {
      const entradas_de_mercancia = {
        idOrdenCompra: this.entradasMercanciaSeleccionadas[i].num_doc_comp,
        noPosicion: this.entradasMercanciaSeleccionadas[i].poscicion_doc,
        cantidad: this.entradasMercanciaSeleccionadas[i].cantidad,
        ejerDocMatnr: this.entradasMercanciaSeleccionadas[i].ejercicio,
        fecha_cont: this.entradasMercanciaSeleccionadas[i].fecha_cont,
        idMaterial: this.entradasMercanciaSeleccionadas[i].num_doc_material,
        importeOC: this.entradasMercanciaSeleccionadas[i].importe,
        indicadorIva: this.entradasMercanciaSeleccionadas[i].ind_iva,
        posDocMatnr: this.entradasMercanciaSeleccionadas[i].num_apunte,
        precioUnitarioOC: this.entradasMercanciaSeleccionadas[i].precio_neto,
        referencia: this.entradasMercanciaSeleccionadas[i].num_doc_ref,
        unidad: this.entradasMercanciaSeleccionadas[i].unidad,
        moneda: this.entradasMercanciaSeleccionadas[i].clave_moneda,
        clase_cond: this.entradasMercanciaSeleccionadas[i].clase_cond,
        doc_ref: this.entradasMercanciaSeleccionadas[i].doc_ref,
        poscicion_doc: this.entradasMercanciaSeleccionadas[i].num_pos_doc_comp,
        denominacion: this.entradasMercanciaSeleccionadas[i].denominacion,
        texto_breve: this.entradasMercanciaSeleccionadas[i].texto_breve,
        num_apunte: this.entradasMercanciaSeleccionadas[i].num_apunte,
        orderpr_un: this.entradasMercanciaSeleccionadas[i].orderpr_un,
        clave_cond_pago: this.entradasMercanciaSeleccionadas[i].clave_cond_pago,
        costo_indirecto: this.entradasMercanciaSeleccionadas[i].costo_indirecto,
        num_nivel: this.entradasMercanciaSeleccionadas[i].num_nivel,
        cont_cond: this.entradasMercanciaSeleccionadas[i].cont_cond,
        HACK_KEY: '',
        bwart: this.entradasMercanciaSeleccionadas[i].bwart,
        noMat: this.entradasMercanciaSeleccionadas[i].noMat,
        tipocambio: this.entradasMercanciaSeleccionadas[i].tcambio,
        fechaPedido: this.entradasMercanciaSeleccionadas[i].fechaPedido,
        bewtp: this.entradasMercanciaSeleccionadas[i].bewtp,
        cond_type: this.entradasMercanciaSeleccionadas[i].cond_type,
        ZAEHK: this.entradasMercanciaSeleccionadas[i].ZAEHK,
        id: i
      };
      this.entradasMercanciaTmp.push(entradas_de_mercancia);
    }

    if (this.multiples) {
      var documentoXML, documentoPDF, nombre_xml, nombre_pdf;
      for (let i = 0; i < this.entradasMercanciaSeleccionadas.length; i++) {

        documentoPDF = (<HTMLInputElement>document.getElementById('pdf' + i));
        documentoXML = (<HTMLInputElement>document.getElementById('xml' + i));

        if (documentoXML.files.item(0) == null) {
          archivosMultiples = false;
          this.toasterService.pop('error', this.cargaArchivosTitulo, this.cargaArchivos);
          break;
        } else {
          archivosMultiples = true;
          if (documentoPDF.files.item(0) != null) {
            nombre_pdf = documentoPDF.files.item(0).name;
          } else {
            nombre_pdf = '';
          }
          if (documentoXML.files.item(0) != null) {
            nombre_xml = documentoXML.files.item(0).name;
          } else {
            nombre_xml = '';
          }

        }

        var dato = [];
        dato.push(this.entradasMercanciaTmp[i]);
        entradas.push(dato); 

        this.datos.push({
          "entradaMercancia": entradas[i],
          "nombre_xml": nombre_xml,
          "nombre_pdf": nombre_pdf
        });

      }

    } else {
      // this.checkNotaCredito = false;
      entradas.push(this.entradasMercanciaTmp);

      this.datos.push({
        "entradaMercancia": entradas[0],
        "nombre_xml": nombreXML,
        "nombre_pdf": nombrePDF
      });
    }

    ordenCompra = JSON.stringify(ordenCompra);
    this.datos = JSON.stringify(this.datos);
    var multiplesFacturas: any = this.multiples;
    var checkNC: any = this.checkNotaCredito;

  // nuevos campos
  
    
    let totalFactura = this.form.get('total').value;
    let folioFactura = this.form.get('folio').value;
    if (!totalFactura) {
      totalFactura = null
    }
    if (!folioFactura) {
      folioFactura = null
    }
    const formData: FormData = new FormData();
    formData.append('sinCfdi', cfdi),
      formData.append('esMasiva', multiplesFacturas),
      formData.append('conNota', checkNC),
      formData.append('proveedor', idUsuario),
      formData.append('ordenCompra', ordenCompra),
      formData.append('datos', this.datos),
      formData.append('totalNotaSinXml', this.importeNC),
      formData.append('notaxml', this.notaXML),
      formData.append('notapdf', this.notaPDF),
      formData.append('contacto', this.personaContacto),
      formData.append('totalFactura', totalFactura),
      formData.append('folioFactura', folioFactura)

      //CAMPOS OKFOODS
      if (this.sociedadOKFI && this.sociedadOKFI !== undefined) { 
        formData.append('indicador', this.sociedadOKFI['indicador']),
        formData.append('descripcion', this.sociedadOKFI['descripcion']),
        formData.append('deducible', this.sociedadOKFI['deducible'])
      }

    if (this.multiples) {
      var documentoXML, documentoPDF;
      for (let i = 0; i < this.entradasMercanciaSeleccionadas.length; i++) {
        documentoPDF = (<HTMLInputElement>document.getElementById('pdf' + i));
        documentoXML = (<HTMLInputElement>document.getElementById('xml' + i));
        if (documentoXML.files.item(0) != null) {
          formData.append('archivosxml', documentoXML.files.item(0))
        } else {
          formData.append('archivosxml', '')
        }

        if (documentoPDF.files.item(0) != null) {
          formData.append('archivospdf', documentoPDF.files.item(0))
        } else {
          formData.append('archivospdf', '')
        }
      }
    } else {

      if (fileXML) {
        formData.append('archivosxml', fileXML)
      } else {
        formData.append('archivosxml', '')
      }

      if (filePDF) {
        formData.append('archivospdf', filePDF)
      } else {
        formData.append('archivospdf', '')
      }


    }

    if (this.paisUsuario == 'MX') {
      if (!this.multiples) {
        if (fileXML &&  this.personaContacto.length>0) {
          enviar = true;
        } else {
          enviar = false;
        }
      } else {
        if (archivosMultiples && this.personaContacto.length>0) {
          enviar = true;
        } else {
          enviar = false;
        }
      }
    } else {
      
      if (!this.multiples) {
        if (filePDF && this.personaContacto.length>0) {
          enviar = true;
        } else {
          enviar = false;
        }
      } else {
        if (archivosMultiples && this.personaContacto.length>0) {
          enviar = true;
        } else {
          enviar = false;
        }
      }
    }

    if (enviar) {
      this.busy = true;
      if (this.multiples) {
        setTimeout(() => {
          // console.log('multiples');
        }, 6000);
      }
      this.emService.enviarFactura(formData).subscribe(
        data => {

          this.busy = false;

          if (data != null) {
            this.verMensaje = true;
            if (data.status == 'S') {
              this.titulo = this.envioDatos;
            } else {
              this.titulo = this.errorEnvioDatos;
            }

            this.mensaje1 = data.message;
            this.estatusEnvio = data.status;

          }

        },
        err => {
          this.busy = false;
          if (err.status === 401) {
            this.storageService.openLogout();
          } else {
            this.busy = false;
          }
        },
      );
    } else {
      this.toasterService.pop('error', 'Error', this.toastCargarArchivos);
    }


  }



}






// WEBPACK FOOTER //
// ./src/app/pages/invoices-em/upload-modal/upload-modal.component.ts